import { MButton } from '@Components/Base';
import { useMemo } from 'react';
import { Modal } from 'antd';

import { FormikHelpers, useFormik } from 'formik';
import {
  MaterialRequisitionDocumentRequest,
  MaterialRequisitionItemFormResponse,
} from '@Types/api/form';
import { ViewTab } from '../../../ViewTab.enum';
import { DocumentEditModalContent } from '../../Section/DocumentItem';
import { MaterialEditModalContent } from '../../Section/MaterialItem';

import styles from './material-modal.module.css';
import { initialMaterialValuesForm } from './formik/materials/initialValues';
import { initialDocumentValuesForm } from './formik/documents/initialValues';

interface EditModalProps {
  showModal: boolean;
  activeTab: keyof typeof ViewTab;
  itemId: string | number;
  onSaveMaterialItem: (
    formikValues: MaterialRequisitionItemFormResponse
  ) => void;
  onSaveDocumentItem: (
    formikValues: MaterialRequisitionDocumentRequest
  ) => void;
  onClose: () => void;
}

type handleSubmitDocumentType = (
  values: MaterialRequisitionDocumentRequest,
  formikHelpers: FormikHelpers<MaterialRequisitionDocumentRequest>
) => void;

type handleSubmitMaterialType = (
  values: MaterialRequisitionItemFormResponse,
  formikHelpers: FormikHelpers<MaterialRequisitionItemFormResponse>
) => void;

const ItemEditModal: React.FC<EditModalProps> = ({
  showModal,
  activeTab,
  itemId,
  onSaveDocumentItem,
  onSaveMaterialItem,
  onClose,
}) => {
  const handleSubmitDocumentForm: handleSubmitDocumentType = () => {};
  const handleSubmitMaterialForm: handleSubmitMaterialType = () => {};

  const formikMaterials = useFormik({
    initialValues: initialMaterialValuesForm,
    enableReinitialize: true,
    onSubmit: handleSubmitMaterialForm,
  });

  const formikDocuments = useFormik({
    initialValues: initialDocumentValuesForm,
    enableReinitialize: true,
    onSubmit: handleSubmitDocumentForm,
  });

  const customButtons = useMemo(() => {
    if (activeTab === 'DOCUMENTS') {
      return [
        <MButton key="back" type="tertiary" onClick={onClose}>
          Cancel
        </MButton>,
        <MButton
          key="submit"
          type="primary"
          onClick={() => onSaveDocumentItem(formikDocuments.values)}
        >
          Save Changes
        </MButton>,
      ];
    }

    return [
      <MButton key="back" type="tertiary" onClick={onClose}>
        Cancel
      </MButton>,
      <MButton
        key="submit"
        type="primary"
        onClick={() => onSaveMaterialItem(formikMaterials.values)}
      >
        Save Changes
      </MButton>,
    ];
  }, [activeTab, formikMaterials.values, formikDocuments.values]);

  return (
    <Modal
      className={styles.materialModal}
      title="Edit Item"
      open={showModal}
      onOk={() => onSaveDocumentItem}
      onCancel={onClose}
      style={{ height: '670px' }}
      width={600}
      footer={customButtons}
    >
      {activeTab === ViewTab.DOCUMENTS && (
        <DocumentEditModalContent itemId={itemId} formik={formikDocuments} />
      )}
      {activeTab === ViewTab.MATERIALS && (
        <MaterialEditModalContent itemId={itemId} formik={formikMaterials} />
      )}
    </Modal>
  );
};

export default ItemEditModal;
